import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/react/20/solid";

export default function SelectAdAstra({ label, value, onChange, options, error }) {
  return (
    <div className="flex flex-col w-full">

      {label && (
        <label className="text-sm font-semibold mb-1 text-gray-700">
          {label}
        </label>
      )}

      <Listbox value={value} onChange={onChange}>
        <div className="relative w-full">

          {/* Button SIN deprecated */}
          <Listbox.Button as={Fragment}>
            <button
              type="button"
              className={`relative w-full cursor-pointer rounded-lg border bg-white py-3 pl-3 pr-10 text-left shadow-sm focus:outline-none transition-all duration-150 ${
                error
                  ? "border-red-300 focus:border-red-400 bg-red-50/50"
                  : "border-gray-300 focus:border-black"
              }`}
            >
              <span className="block truncate">
                {value || "Seleccione una opción"}
              </span>

              <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                <ChevronUpDownIcon className="h-5 w-5 text-gray-500" />
              </span>
            </button>
          </Listbox.Button>

          {/* OPTIONS */}
          <Transition
            as={Fragment}
            enter="transition ease-out duration-150"
            enterFrom="opacity-0 -translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 -translate-y-1"
          >
            <Listbox.Options
              className="absolute z-[9999] mt-2 max-h-60 w-full overflow-auto rounded-lg bg-white py-2 text-base shadow-lg ring-1 ring-black/10 focus:outline-none"
            >
              {options.length > 0 ? (
                options.map((op, idx) => (
                  <Listbox.Option
                    key={idx}
                    value={op}
                    className={({ active }) =>
                      `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                        active ? "bg-black/5 text-black" : "text-gray-800"
                      }`
                    }
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? "font-semibold" : "font-normal"
                          }`}
                        >
                          {op}
                        </span>

                        {selected && (
                          <span className="absolute inset-y-0 left-3 flex items-center text-black">
                            <CheckIcon className="h-5 w-5" />
                          </span>
                        )}
                      </>
                    )}
                  </Listbox.Option>
                ))
              ) : (
                <div className="py-2 px-4 text-gray-500 text-sm">
                  Selecciona primero la provincia y luego el Cantón
                </div>
              )}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>

      {error && (
        <p className="text-[11px] mt-1 pl-1 text-red-500 font-medium animate-fadeIn">
          {error}
        </p>
      )}
    </div>
  );
}
